import { COUNTRY_NAMES } from '@constants/countries';
import { normalizeSearchText, searchTerms } from '@helpers/search';

const PHONE_TERM = /^[\d()+.-]+$/;

const digitsOf = text => (text || '').replace(/\D/g, '');

const searchableText = location =>
    normalizeSearchText(
        [
            location.title,
            ...(location.addressLines || []),
            location.city,
            location.region,
            location.postalCode,
            COUNTRY_NAMES[location.country],
            location.country,
        ].join(' '),
    );

const matchesPhone = (term, phoneDigits) => {
    if (!PHONE_TERM.test(term)) return false;
    const termDigits = digitsOf(term);
    return !termDigits || phoneDigits.includes(termDigits);
};

export const googleLocationKey = location => `${location.integrationId}:${location.locationId}`;

export const indexGoogleLocations = locations =>
    locations.map(location => ({
        location,
        text: searchableText(location),
        phoneDigits: digitsOf(location.primaryPhoneNumber),
    }));

export const filterGoogleLocations = (
    index,
    { query = '', hideConnected = false, hideUnverified = false, selectedKeys = new Set() },
) => {
    const terms = searchTerms(query);
    const matchesFilters = ({ location, text, phoneDigits }) =>
        !(hideConnected && location.connected) &&
        !(hideUnverified && !location.isVerified) &&
        terms.every(term => text.includes(term) || matchesPhone(term, phoneDigits));

    const matching = [];
    const visible = [];
    index.forEach(entry => {
        const matches = matchesFilters(entry);
        if (matches) matching.push(entry.location);
        if (matches || selectedKeys.has(googleLocationKey(entry.location))) visible.push(entry.location);
    });
    return { matching, visible };
};
